import { cn } from '@/lib/utils';

interface ScorePillProps {
  score: number | null;
  className?: string;
}

function getScoreColor(score: number): string {
  if (score >= 4) return 'bg-emerald-100 text-emerald-700 border-emerald-200';
  if (score >= 3) return 'bg-blue-100 text-blue-700 border-blue-200';
  if (score >= 2) return 'bg-amber-100 text-amber-700 border-amber-200';
  return 'bg-red-100 text-red-700 border-red-200';
}

export function ScorePill({ score, className }: ScorePillProps) {
  if (score === null || score === undefined) {
    return (
      <span className={cn('inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium bg-muted text-muted-foreground', className)}>
        —
      </span>
    );
  }

  return (
    <span className={cn('inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold', getScoreColor(score), className)}>
      {score.toFixed(1)}
    </span>
  );
}
